import React from 'react';
export const Icon = ({ children, size = 20, width, height, title, ...props }) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: width || size, height: height || size, viewBox: "0 0 20 20", ...props },
        title && React.createElement("title", null, title),
        children));
};
//# sourceMappingURL=Icon.js.map